import React from "react";
import PlatformSettings from "../PlatformSettings";
import { indiaCatalog } from "../../utils/catalogSources";

/** India "Payout Settings" page: the Australian settings page on India settings (₹). */
const IndiaPlatformSettings = () => <PlatformSettings source={indiaCatalog} />;

export default IndiaPlatformSettings;
